import { jsxs, jsx } from 'react/jsx-runtime';

const ErrorIconType404 = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M13.3391 13.0696C14.7652 11.6435 17.0774 11.6435 18.5035 13.0696L37.434 32L18.5035 50.9304C17.0774 52.3565 14.7652 52.3565 13.3391 50.9304C11.913 49.5043 11.913 47.1921 13.3391 45.766L27.1051 32L13.3391 18.234C11.913 16.8079 11.913 14.4957 13.3391 13.0696Z",
            fill: "#0F7AED"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M34.3573 39.8059L45.4818 50.9304C46.9079 52.3565 49.2201 52.3565 50.6462 50.9304C52.0723 49.5043 52.0723 47.1921 50.6462 45.766L39.5217 34.6415L34.3573 39.8059Z",
            fill: "#38D200"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M39.5217 29.3585L50.6462 18.234C52.0723 16.8079 52.0723 14.4957 50.6462 13.0696C49.2201 11.6435 46.9079 11.6435 45.4818 13.0696L34.3573 24.1941L39.5217 29.3585Z",
            fill: "#38D200"
          }
        )
      ]
    }
  );
};

export { ErrorIconType404 };
